import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSettingsGearBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M11.245 21.5h1.509a2.596 2.596 0 0 0 2.593-2.593.63.63 0 0 1 .32-.555.63.63 0 0 1 .641 0 2.594 2.594 0 0 0 3.542-.949l.754-1.306c.346-.6.438-1.298.259-1.967a2.58 2.58 0 0 0-1.208-1.575.63.63 0 0 1-.321-.555c0-.111.032-.388.321-.555a2.58 2.58 0 0 0 1.208-1.574 2.58 2.58 0 0 0-.259-1.968l-.754-1.306a2.58 2.58 0 0 0-1.574-1.208 2.57 2.57 0 0 0-1.968.259.63.63 0 0 1-.64 0 .63.63 0 0 1-.321-.555A2.596 2.596 0 0 0 12.754 2.5h-1.509a2.595 2.595 0 0 0-2.592 2.593c0 .334-.224.5-.321.555a.63.63 0 0 1-.64-.001 2.58 2.58 0 0 0-1.968-.258 2.58 2.58 0 0 0-1.573 1.208l-.756 1.307a2.594 2.594 0 0 0 .95 3.54c.289.168.32.445.32.556a.63.63 0 0 1-.32.555 2.596 2.596 0 0 0-.949 3.542l.754 1.306c.346.6.905 1.029 1.574 1.208.668.18 1.368.087 1.968-.259a.63.63 0 0 1 .64 0 .63.63 0 0 1 .321.555 2.595 2.595 0 0 0 2.592 2.593"
      opacity={0.4}
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.212 12A3.212 3.212 0 1 0 8.787 12a3.212 3.212 0 0 0 6.425.001"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSettingsGearBulk);
export default ForwardRef;
